import React from 'react';
import HideAppBar from 'view/FrontEnd/HomePage/components/HideAppBar';
import Footer from 'view/FrontEnd/HomePage/components/Footer';
import ContentProject from './ContentProject';
import BKImage from "assets/images/Parallax/SessionH/BG_Project.png";
import { styled, Grid } from '@mui/material';
import BreadcrumbsBar from 'components/Breadcrumbs';

const ContainerBG = styled("div")({
    backgroundImage: `url(${BKImage})`,
    backgroundPositionX: "center",
    backgroundPosittionY: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundAttachment: "fixed",
    padding: '10% 4% 12% 6%',
});

const LayoutFrontProject = ({ children }) => {
    
    return (
        <React.Fragment>
            <ContainerBG>               
                <HideAppBar />  
                <Grid item container spacing={1} xs={12} md={12}>
                    <Grid item xs={12} sm={12} md={12}>
                        <BreadcrumbsBar isFrontEndProject={true} />
                    </Grid>
                    <ContentProject children={children} />
                </Grid>
            </ContainerBG>
            <Footer/>   
        </React.Fragment>     
    )
}
export default LayoutFrontProject
